module.exports = __webpack_public_path__ + "themes/mf/img/logo-title.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/logo-title.png
// module id = 77
// module chunks = 3